module.exports = __webpack_public_path__ + "static/media/galeryCoatings5.94144724.jpg";